/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LocationRateDto } from './locationRateDto';
import { PricingType } from './pricingType';


export interface LocationDto { 
    id?: number;
    code: string;
    name: string;
    address: string;
    phoneNumber: string;
    timeZoneId?: string | null;
    taxType?: PricingType;
    readonly taxTypeFormatted?: string | null;
    tax?: number;
    readonly taxFormatted?: string | null;
    serviceFeeType?: PricingType;
    readonly serviceFeeTypeFormatted?: string | null;
    serviceFee?: number;
    readonly serviceFeeFormatted?: string | null;
    locationRates?: Array<LocationRateDto> | null;
    bannerImage?: string | null;
}
export namespace LocationDto {
}


